import { ApplicationConfig, APP_INITIALIZER, ErrorHandler, isDevMode, LOCALE_ID, inject } from '@angular/core';
import { provideRouter, Router, withComponentInputBinding, withPreloading, withInMemoryScrolling } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { environment } from './environment/environment';
import { PreloadConRetrasoStrategy } from './core/preload/preload-con-retraso.strategy';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { registerLocaleData } from '@angular/common';
import localeEsAR from '@angular/common/locales/es-AR';
import { PaginatorIntlService } from './shared/services/paginator-intl.service';

// Importación de rutas
import { routes } from './app.routes';
import { authInterceptor } from './services/auth.interceptor';
import { AuthService } from './services/auth.service';
import { AUTH_SERVICE_TOKEN } from './core/services/auth.token';
import { GlobalErrorHandler } from './core/services';
import { retryInterceptor } from './core/interceptors';
import { subscriptionInterceptor } from './core/interceptors/subscription.interceptor';
import { provideServiceWorker } from '@angular/service-worker';

registerLocaleData(localeEsAR);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withComponentInputBinding(),
      withPreloading(PreloadConRetrasoStrategy),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
    ),
    provideHttpClient(
      withFetch(),
      withInterceptors([retryInterceptor, authInterceptor, subscriptionInterceptor])
    ),
    provideAnimationsAsync(),
    provideNativeDateAdapter(),
    { provide: LOCALE_ID, useValue: 'es-AR' },
    { provide: MatPaginatorIntl, useClass: PaginatorIntlService },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: AUTH_SERVICE_TOKEN, useExisting: AuthService },
    ...(environment.sentryDsn
      ? [
          { provide: Sentry.TraceService, deps: [Router] },
          {
            provide: APP_INITIALIZER,
            useFactory: () => () => {},
            deps: [Sentry.TraceService],
            multi: true,
          },
        ]
      : []),
    provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerImmediately'
          })
  ]
};